import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Breadcrumb } from '@shared/models/breadcrumb.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    updatedLabel: BehaviorSubject<Breadcrumb> = new BehaviorSubject(null);
    updatedLabel$ = this.updatedLabel.asObservable();

    private dynamicBreadcrumbs: Breadcrumb[] = [];

    build(route: ActivatedRouteSnapshot, url = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
        if (route.firstChild) {
            url +=
                '/' +
                route.firstChild.url
                    .map((segment) => {
                        return segment.path;
                    })
                    .join('/');

            if (!route.firstChild.data?.breadcrumb.skip) {
                breadcrumbs.push({
                    label: this.getDynamicLabel(route.firstChild.data.breadcrumb.alias),
                    ...route.firstChild.data.breadcrumb,
                    url,
                });
            }

            return this.build(route.firstChild, url, breadcrumbs);
        }

        return breadcrumbs;
    }

    removeOutdated(breadcrumbs: Breadcrumb[]): void {
        this.dynamicBreadcrumbs = this.dynamicBreadcrumbs.filter((breadcrumb) => {
            return breadcrumbs.find((existedBreadcrumb) => {
                return existedBreadcrumb.alias === breadcrumb.alias;
            });
        });
    }

    setLabel(alias: string, value: string) {
        const breadcrumb = this.dynamicBreadcrumbs.find((dynamicBreadcrumb) => {
            return dynamicBreadcrumb.alias === alias;
        });

        if (breadcrumb) {
            breadcrumb.label = value;
        } else {
            this.dynamicBreadcrumbs.push({
                alias,
                label: value,
            });
        }
        this.updatedLabel.next({
            alias,
            label: value,
        });
    }

    private getDynamicLabel(alias): string {
        const currentBreadcrumb = this.dynamicBreadcrumbs.find((breadcrumb) => {
            return breadcrumb.alias === alias;
        });

        return currentBreadcrumb?.label || '...';
    }
}
